import { Component, OnInit, Input, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../../services/api-endpoints";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-authtype-edit',
  templateUrl: `./authtype-edit.component.html`,
})
export class AuthtypeEditComponent implements OnInit {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public isAdminSubscription: Subscription;
  public allAuthTypes: string[] = ['NoAuth', 'BasicAuth'];
  public hasError = false;
  public errorMessage;
  public errorMessageAuthUsername;
  public errorMessageAuthPassword;
  public initialValue = [{}];

  private authType:string;
  private authUsername:string;
  private authPassword:string;

  @Input() inputAuthType;
  @Input() inputAuthUsername;
  @Input() inputAuthPassword;
  @Input() virtId;

  constructor(private userVerificationService: UserVerificationService,
              private http: HttpClient) {
    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick() {
    this.inputIsDisable = false;
    this.hasError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
  }

  inputOnSave() {
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    var url = '';
    var body: any = {};

    url = ApiEndpoints.UPDATE_AUTH;
    if(this.authType == 'BasicAuth') body = {"virtId": this.virtId, "authType": this.authType, "authUsername": this.authUsername, "authPassword": this.authPassword};
    else body = {"virtId": this.virtId, "authType": this.authType};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.inputIsDisable = true;
          this.inputIsHidden = false;
          this.selectIsDisable = false;
          this.hasError = false;
          this.errorMessage = "";
          this.errorMessageAuthPassword = "";
          this.errorMessageAuthUsername = "";
          this.selectIsHidden = true;
          this.initialValue = [{}];
          this.inputAuthType = this.authType;
          this.inputAuthUsername = this.authUsername;
          this.inputAuthPassword = this.authPassword;
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.errorMessageAuthUsername = "";
            this.errorMessageAuthPassword = "";
            this.hasError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.hasError = false;
    this.errorMessage = "";
    this.errorMessageAuthPassword = "";
    this.errorMessageAuthUsername = "";
    this.initialValue = [{}];
  }

  selectedAuthType(value:any):void {
    this.hasError = false;
    this.authType = value.split(",",1)[0];
    if (this.authType == 'BasicAuth') {
      if(this.authUsername === "") {
        this.errorMessageAuthUsername = "Auth Username  is required.";
        this.hasError = true;
      }
      if(this.authPassword === "") {
        this.errorMessageAuthPassword = "Auth Password is required."
        this.hasError = true;
      }
    }
  }

  authDetailsHidden() {
    if(this.authType === 'BasicAuth') return false;
    return true;
  }

  testValidation(validationType, inputCheck, inputElement, event: any) {
    this.hasError = false;

    if(validationType == 'authUsername') this.authUsername = inputCheck;
    else if(validationType == 'authPassword') this.authPassword = inputCheck;

    if (this.authType == 'BasicAuth') {
      if(this.authUsername == "") {
        this.errorMessageAuthUsername = "Auth Username  is required.";
        this.hasError = true;
      }
      if(this.authPassword == "") {
        this.errorMessageAuthPassword = "Auth Password is required."
        this.hasError = true;
      }
    }
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ')
  }

  ngOnInit() {
    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
    this.authType = this.inputAuthType;
    this.authUsername = this.inputAuthUsername;
    this.authPassword = this.inputAuthPassword;
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

}
